import React from "react";

import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";

import TheaterComedyIcon from '@mui/icons-material/TheaterComedy';
import { Link } from "react-router-dom";

import Style from "../../../styles/js/Styles.js";

export default function CultureMenu( ) {

  const style = Style();
  
  return (
    <div>
      <ListItem button component={Link} to={"/culture/cultural-ads"} >
        <ListItemIcon>
          <TheaterComedyIcon />
        </ListItemIcon>
        <ListItemText className={style.menuTextItem} primary="Cultura" />
      </ListItem>
    </div>
    
  );
}
